import React, { Component, useState } from 'react';
import Lightroom from 'react-lightbox-gallery'


class Gallery extends Component {
	

    render() {

		let publicUrl = process.env.PUBLIC_URL+'/'

		var images = [
			{
			  src: 'assets/img/website/gallery/1.jpeg',
			  desc: '',
			  sub: ''
			},
			{
				src: 'assets/img/website/gallery/2.jpeg',
				desc: '',
				sub: ''
			  },
			  {
				src: 'assets/img/website/gallery/3.jpeg',
				desc: '',
				sub: ''
			  },
			  {
				src: 'assets/img/website/gallery/4.jpeg',
				desc: '',
				sub: ''
			  },
			  {
				src: 'assets/img/website/gallery/5.jpeg',
				desc: '',
				sub: ''
			  },
			  {
				src: 'assets/img/website/gallery/6.jpeg',
				desc: '',
				sub: ''
			  },
			  {
				src: 'assets/img/website/gallery/7.jpeg',
				desc: '',
				sub: ''
			  }
			
		  ]
		  var settings = {
			columnCount:{
			  default:4,
			  mobile:3,
			  tab:4
			},
			mode: 'light'
		  }



    return  <div className="team-area pd-top-120 pd-bottom-90 go-top">
			  <div className="container">
			  	<div className="row">
					<h3>MIET Industrial Training Centre (ITI) - Convocation Day 2022 - 23rd Sep, 2022.</h3><br/><br/>
				  <Lightroom images={images} settings={settings} />
				</div>
			  </div>
			</div>

        }
}

export default Gallery